import { Layout } from "@/components/Layout";
import { Route, MapPin, ExternalLink, Construction } from "lucide-react";

export default function SentieriPage() {
  return (
    <Layout>
      <section className="bg-[#1f2d22] text-white py-16 sm:py-20" data-testid="sentieri-header">
        <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/20 px-4 py-1.5 mb-5">
            <Route className="w-3.5 h-3.5 text-[#E8C9A0]" />
            <span className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.22em] text-[#E8C9A0]">
              Mappa sentieri
            </span>
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black leading-[1.05] tracking-tight">
            Sentieri del <span className="italic font-light text-[#E8C9A0]">Monte Pisano.</span>
          </h1>
          <p className="mt-5 text-base sm:text-lg text-white/75 max-w-2xl leading-relaxed">
            Stiamo lavorando a una mappa interattiva dei sentieri, percorsi e punti di
            interesse del Monte Pisano.
          </p>
        </div>
      </section>

      <section className="py-14 sm:py-20 bg-[#FBF9F6]">
        <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className="rounded-3xl bg-white border-2 border-[#E5E1D8] p-7 sm:p-10 text-center">
            <div className="w-16 h-16 mx-auto rounded-2xl bg-[#C19A3D] text-white flex items-center justify-center mb-5">
              <Construction className="w-8 h-8" strokeWidth={1.6} />
            </div>
            <h2 className="font-display text-2xl sm:text-3xl font-black text-[#1A1A1A] leading-tight">
              In aggiornamento
            </h2>
            <p className="mt-4 text-base text-[#5C5C5C] leading-relaxed">
              La mappa interattiva dei sentieri sarà disponibile nelle prossime
              settimane. Stiamo catalogando i percorsi insieme ad associazioni
              locali e volontari del territorio.
            </p>
            <p className="mt-5 text-sm text-[#5C5C5C] italic">
              Nel frattempo, puoi consultare i sentieri tramite cartografie ufficiali.
            </p>
            <div className="mt-7 flex flex-wrap gap-3 justify-center">
              <a
                href="https://www.openstreetmap.org/#map=13/43.738/10.500"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="sentieri-osm-link"
                className="inline-flex items-center gap-2 rounded-full bg-[#2E4F3B] hover:bg-[#1f3828] text-white font-bold px-6 py-3 transition-colors"
              >
                <MapPin className="w-4 h-4" />
                Apri OpenStreetMap
                <ExternalLink className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
